import { Masonry } from '@mui/lab'
import { Grid } from '@mui/material'
import { GreenText, Title } from 'components'
import { useAuth } from 'context'
import { Navigate } from 'react-router-dom'
import CustomerExportReportCard from './CustomerExportReportCard'

export default function Reports() {
  const { permissions } = useAuth()

  if (!permissions.ADMINISTRATION_ADD_EDIT) {
    return <Navigate to='/' />
  }

  return (
    <>
      <Title>Reports</Title>

      <Grid container id='reports-page' spacing={2} alignItems='flex-start'>
        <Grid item xs={12}>
          <Masonry columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} sequential sx={{ margin: 0 }}>
            <CustomerExportReportCard />
          </Masonry>
        </Grid>

        <Grid item xs={12}>
          <GreenText>
            {`Reports are only accessible by users with "Administration add/edit" VTS2 Access.`}
          </GreenText>
        </Grid>
      </Grid>
    </>
  )
}
